import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from 'src/shared/services/translate.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss']
})
export class DashboardAdminComponent implements OnInit {
  academicYear = null;

  constructor(private route: ActivatedRoute, private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate.load('extracurricular', 'dashboard');
  }

  onChangeAcademicYear(event: any) {
    this.academicYear = event ? event.academic_year : null;
  }
}
